import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
// import AssignmentIcon from '@material-ui/icons/Assignment';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MenuIcon from '@material-ui/icons/Menu';
import WorkIcon from '@material-ui/icons/Work';
import PersonIcon from '@material-ui/icons/Person';
import React, {
  forwardRef,
  useCallback,
  useContext,
  useRef,
  useState,
} from 'react';
import { Link } from 'react-router-dom';
import routes from '../routes';
import { AuthContext } from './Authentication';

interface MenuItemLinkProps {
  icon?: React.ReactElement;
  to: string;
  text: string;
  target?: string;
}

// TODO check if we can have only one component here and not having the forwardRef problem
function MenuItemLink({
  to,
  text,
  target,
  icon = undefined,
}: MenuItemLinkProps) {
  return (
    <MenuItem component={Link} to={to} target={target}>
      {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
      {text}
    </MenuItem>
  );
}

const FRMenuItemLink = forwardRef<any, any>(
  (props, ref) => (
    <li ref={ref}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <MenuItemLink {...props} />
    </li>
  ),
);

const useStyles = makeStyles((theme) => ({
  userBox: {
    cursor: 'pointer',
    flex: 0,
  },
  signInButton: {
    textAlign: 'right',
  },
  logoContainer: {
    marginRight: theme.spacing(2),
    '& .MuiAvatar-root': {
      display: 'inline-block',
      verticalAlign: 'middle',
      marginRight: theme.spacing(1),
    },
    '& span': {
      display: 'none',
    },
    '@media (min-width: 480px)': {
      '& h6': {
        whiteSpace: 'nowrap',
      },
      '& span': {
        display: 'inline-block',
      },
    },
  },
}));

export default function Header() {
  const classes = useStyles();
  const menuButtonRef = useRef<HTMLElement>(null!);
  const { isSignedIn, user, signOut } = useContext(AuthContext);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleOpenToggle = useCallback(
    () => setAnchorEl(anchorEl ? null : menuButtonRef.current),
    [anchorEl],
  );
  const handleClose = useCallback(() => setAnchorEl(null), []);
  return (
    <AppBar position="sticky" color="default">
      <Toolbar>
        <Box flexGrow={1} className={classes.logoContainer}>
          <a href="https://matildaexp.com" target="_blank" rel="noreferrer">
            <Typography variant="h6" color="textPrimary">
              <Avatar alt="logo" src={`${process.env.PUBLIC_URL}/logo.png`} />
              <span>Matilda Explorations</span>
            </Typography>
          </a>
        </Box>
        {isSignedIn && user
          && (
            <Box margin={1} className={classes.userBox}>
              {/* eslint-disable-next-line react/jsx-props-no-spreading */}
              <Box {...{ ref: menuButtonRef } as any} display="flex" alignItems="center" onClick={handleOpenToggle}>
                <Avatar src={user.picture}>{user.github}</Avatar>
                <Box margin={1} whiteSpace="nowrap">
                  {user.github}
                </Box>
                <IconButton aria-label="open menu" color="inherit">
                  <MenuIcon />
                </IconButton>
              </Box>
              <Menu
                anchorEl={anchorEl}
                getContentAnchorEl={null}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                MenuListProps={{ onMouseLeave: handleClose }}
              >
                {/* <FRMenuItemLink
                  to={routes.home}
                  icon={<AssignmentIcon fontSize="small" />}
                  text="Your application"
                /> */}
                <FRMenuItemLink
                  to={routes.profile.root}
                  icon={<PersonIcon fontSize="small" />}
                  text="Profile"
                />
                <FRMenuItemLink
                  to={routes.jobs.root}
                  icon={<WorkIcon fontSize="small" />}
                  text="Jobs"
                />
                <FRMenuItemLink
                  to={{ pathname: 'mailto:engineers@matildaexp.com' }}
                  target="_blank"
                  icon={<ContactSupportIcon fontSize="small" />}
                  text="Support"
                />
                <MenuItem onClick={signOut as () => void}>
                  <ListItemIcon>
                    <ExitToAppIcon fontSize="small" />
                  </ListItemIcon>
                  Sign Out
                </MenuItem>
              </Menu>
            </Box>
          )}
        {!isSignedIn
          && (
            <Button
              className={classes.signInButton}
              component={Link}
              to={routes.signIn}
            >
              Already&nbsp;have an&nbsp;account?
            </Button>
          )}
      </Toolbar>
    </AppBar>
  );
}
